import classNames from 'classnames';
import React, { memo } from 'react';

import styles from 'src/widgets/policy/components/links.module.scss';

import { useAnalytics } from '@features/Analytics';

export const PolicyLink = memo(
  ({
    place,
    className,
    children,
  }: {
    place: 'paywall' | 'checkout' | 'burger_menu' | 'email_modal' | 'upsale';
    className?: string;
    children?: React.ReactNode;
  }) => {
    const { trackGoogleEvent } = useAnalytics();
    return (
      <a
        className={classNames(styles.link, className)}
        href="https://legal.mentalgrowth.app/eclipse/privacy.pdf"
        target="_blank"
        rel="noreferrer"
        onClick={() =>
          trackGoogleEvent({
            eventName: 'link_open',
            options: { place: place, link_name: 'privacy policy' },
          })
        }>
        {children || <>Privacy Policy</>}
      </a>
    );
  },
);

PolicyLink.displayName = 'PolicyLink';
